
import { useState } from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    try {
      const formData = new FormData();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d41rm46qegfu99c5kdb0', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        setIsSubmitted(true);
        setEmail('');
        setTimeout(() => setIsSubmitted(false), 3000);
      }
    } catch (error) {
      console.error('Erro ao enviar newsletter:', error);
    }
  };

  return (
    <footer>
      {/* Newsletter Section */}
      <section 
        className="py-16 text-white max-md:py-12"
        style={{ backgroundColor: '#0F3F2F' }}
      >
        <div className="container mx-auto px-6 text-center max-md:px-4">
          <h2 
            className="text-4xl font-bold mb-4 max-md:text-2xl"
            style={{ fontFamily: 'Cinzel Decorative, serif' }}
          >
            Junte-se ao Círculo DLUXMEN
          </h2>
          <p 
            className="text-xl mb-8 max-w-2xl mx-auto max-md:text-lg max-md:mb-6"
            style={{ 
              color: '#F8F8F8',
              fontFamily: 'Montserrat, sans-serif'
            }}
          >
            Acesso exclusivo a lançamentos, descontos VIP e novidades em primeira mão.
          </p>

          {isSubmitted ? (
            <div 
              className="text-lg font-semibold"
              style={{ 
                color: '#F8F8F8',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              ✓ Bem-vindo ao Círculo DLUXMEN!
            </div>
          ) : (
            <form 
              onSubmit={handleNewsletterSubmit}
              className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto"
              data-readdy-form
              id="newsletter-form"
            >
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Seu endereço de email"
                required
                className="flex-1 px-6 py-4 rounded-lg text-black focus:outline-none focus:ring-2 focus:ring-white/50"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              />
              <button
                type="submit"
                className="px-8 py-4 bg-white text-black font-semibold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Participar Agora
              </button>
            </form>
          )}
        </div>
      </section>

      {/* Main Footer */}
      <section 
        className="py-12 max-md:py-8"
        style={{ backgroundColor: '#0F3F2F' }}
      >
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-white">
            {/* Shop */}
            <div>
              <h3 
                className="text-lg font-bold mb-4"
                style={{ 
                  fontFamily: 'Cinzel Decorative, serif',
                  color: '#F8F8F8'
                }}
              >
                Shop
              </h3>
              <ul className="space-y-2">
                {[
                  { path: '/masculino', label: 'Masculino' },
                  { path: '/feminino', label: 'Feminino' },
                  { path: '/bags', label: 'Bags' },
                  { path: '/accessories', label: 'Accessories' },
                  { path: '/watches', label: 'Watches' },
                  { path: '/outlet', label: 'Outlet' }
                ].map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className="transition-colors hover:text-white"
                      style={{ 
                        color: '#C0C0C0',
                        fontFamily: 'Montserrat, sans-serif'
                      }}
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Support */}
            <div>
              <h3 
                className="text-lg font-bold mb-4"
                style={{ 
                  fontFamily: 'Cinzel Decorative, serif',
                  color: '#F8F8F8'
                }}
              >
                Suporte
              </h3>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/contatos"
                    className="transition-colors hover:text-white"
                    style={{ 
                      color: '#C0C0C0',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    Contato
                  </Link>
                </li>
                <li>
                  <span
                    style={{ 
                      color: '#C0C0C0',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    Política de Troca
                  </span>
                </li>
                <li>
                  <span
                    style={{ 
                      color: '#C0C0C0',
                      fontFamily: 'Montserrat, sans-serif'
                    }}
                  >
                    Envios
                  </span>
                </li>
              </ul>
            </div>

            {/* Follow Us */}
            <div>
              <h3 
                className="text-lg font-bold mb-4"
                style={{ 
                  fontFamily: 'Cinzel Decorative, serif',
                  color: '#F8F8F8'
                }}
              >
                Siga-nos
              </h3>
              <div className="flex space-x-4">
                <a
                  href="https://www.instagram.com/dlux_men_/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full transition-colors hover:bg-white/10"
                  style={{ color: '#C0C0C0' }}
                >
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a
                  href="https://wa.me/5511945589527"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full transition-colors hover:bg-white/10"
                  style={{ color: '#C0C0C0' }}
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                </a>
              </div>
            </div>

            {/* Store Info */}
            <div>
              <h3 
                className="text-lg font-bold mb-4"
                style={{ 
                  fontFamily: 'Cinzel Decorative, serif',
                  color: '#F8F8F8'
                }}
              >
                Loja Física
              </h3>
              <div 
                className="text-sm space-y-1"
                style={{ 
                  color: '#C0C0C0',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                <p>Brás – Circuito de Compras</p>
                <p>1º Andar – Loja 1136</p>
                <p>Corredor Central – Loja Verde</p>
                <p className="mt-2 font-semibold">Seg-Sáb: 08:00-16:00</p>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-white/20 mt-8 pt-8 flex flex-col md:flex-row items-center justify-between">
            <p 
              className="mb-4 md:mb-0"
              style={{ 
                color: '#C0C0C0',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              © 2025 DLUXMEN. Todos os direitos reservados.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors hover:text-white"
              style={{ 
                color: '#C0C0C0',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
